import { useMarketInfo } from '@/domain/market-info/useMarketInfo'
import { CheckedAddress } from '@/domain/types/CheckedAddress'
import { SwapContainer } from '@/features/swap/SwapContainer'
import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { TokenSymbolEnum, getAddressBySymbol } from '@/utils/tokens'
import { useChainId } from 'wagmi'

export function BuyUsdxl() {
  const chainId = useChainId()
  const { marketInfo } = useMarketInfo({ chainId })

  const usdxlAddress = CheckedAddress(getAddressBySymbol(TokenSymbolEnum.USDXL))
  const usdxlToken = marketInfo.findOneReserveByUnderlyingAsset(usdxlAddress).token

  return (
    <Panel.Wrapper className="bg-panel">
      <div className="flex flex-col gap-4 p-6 md:p-8">
        <Typography variant="h3" gradient className="text-xl">
          Buy USDXL
        </Typography>
        <Typography variant="p" className="text-muted-foreground leading-relaxed">
          Swap any token for USDXL
        </Typography>
        <div className="mx-auto w-full max-w-xl">
          <SwapContainer simplified isModal token={usdxlToken} lockToToken stackedSuccessScreen />
        </div>
      </div>
    </Panel.Wrapper>
  )
}
